import { gql } from '@apollo/client'

export const errorMessageFragment = gql`
  fragment errorMessageFragment on ErrorMessage {
    path
    message
  }
`
